export default theme => ({
  container: {
    backgroundColor: theme.palette.green.main,
    color: theme.palette.green.contrastText,
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  titleSep: {
    width: 70,
    height: 4,
    backgroundColor: theme.palette.common.white,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  buttonPdf: {
    marginBottom: theme.spacing(6),
  },
  sliderNav: {
    height: theme.spacing(8),
    position: 'relative',
  },
  arrowBack: {
    position: 'absolute',
    top: theme.spacing(1),
    left: -theme.spacing(6),
    '& svg': {
      transform: 'translateX(5px)',
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  arrowForward: {
    position: 'absolute',
    top: theme.spacing(1),
    right: -theme.spacing(6),
    [theme.breakpoints.down('md')]: {
      right: 0,
    },
  },
  sliderTitle: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    left: 0,
    top: 0,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      width: `calc(100% - ${theme.spacing(6)}px)`,
    },
  },
  sliderTitleDisable: {
    pointerEvent: 'none',
  },
  greenHexaLeft: {
    marginRight: -theme.spacing(4),
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  greenHexaRight: {
    marginLeft: -theme.spacing(4),
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  mainHexa: {
    position: 'relative',
    zIndex: 20,
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      width: 40,
      height: 44,
    },
  },
  sliderTitleText: {
    marginLeft: theme.spacing(3),
    fontWeight: 400,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.2rem',
    },
  },
  hexaRightContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  sliderContent: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    position: 'relative',
    marginTop: theme.spacing(4),
  },
  sliderContentText: {
    columns: 3,
    columnGap: theme.spacing(4),
    display: 'inline-block',
    whiteSpace: 'normal',
    [theme.breakpoints.down('md')]: {
      columns: 1,
    },
  },
  sliderContentTextDisable: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
});
